import { rem, Bold } from '@core-web/typography';
import { Box, styled } from '@mui/material';

export const SuccessModalWrapper = styled(Box)(({ theme: { palette, breakpoints } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${rem(64) + ' ' + rem(24)}`,
  backgroundColor: palette.colors.white,
  boxShadow: palette.boxShadow.modalShadow,
  borderRadius: rem(12),
  width: rem(600),
  gap: rem(16),
  [breakpoints.down(700)]: {
    width: '80%',
  },
}));

export const ModalHeader = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

export const SuccessModalIconWrapper = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  color: palette.colors.green_600,
  fontSize: rem(64),

  ' svg': {
    fontSize: 'inherit',
  },
  '&.danger': {
    color: palette.error.main,
  },
}));

export const ModalBody = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: rem(8),
}));

export const SuccessModalHeading = styled(Box)(({ theme: { palette } }) => ({
  fontSize: rem(20),
  fontWeight: Bold._600,
  lineHeight: rem(28),
  letterSpacing: '-0.5px',
  color: palette.colors.grey_900,
}));

export const SuccessModalMessage = styled(Box)(({ theme: { palette } }) => ({
  fontSize: rem(16),
  fontWeight: Bold._500,
  lineHeight: rem(24),
  letterSpacing: '-0.2px',
  color: palette.colors.grey_500,
}));
